import { useMutation } from '@apollo/client/react';
import { Button, Modal } from 'antd';
import React from 'react';
import useLazyQueryWithCallbacks from '../../../../../../../common/CommonUseLazyQuery';
import useRouter from '../../../../../../../common/useRouter';
import { DELETE_REGISTER_DETAIL } from '../../../../../graphql/Mutation';
import { GET_REGISTER } from '../../../../../graphql/Queries';

const DeletePropertyModal = ({
  showModal,
  setShowModal,
  selectedProperty,
  setSelectedProperty,
  setPropertyDetails,
  setTableColumns,
}) => {
  const {
    params: { registerId },
  } = useRouter();

  const [getRegister] = useLazyQueryWithCallbacks(GET_REGISTER, {
    fetchPolicy: 'network-only',
    onError() {},
    onCompleted(response) {
      const registerDetails = response?.getRegister?.registerDetails;
      const registerFormFields = response?.getRegister?.registerFormFields;
      setPropertyDetails(registerDetails);
      setTableColumns(registerFormFields);
      setShowModal(false);
    },
  });

  const [deleteRegisterDetails] = useMutation(DELETE_REGISTER_DETAIL, {
    fetchPolicy: 'network-only',
    onError() {},
    onCompleted() {
      setSelectedProperty();
      getRegister({ variables: { getRegisterId: registerId } });
    },
  });

  const handleOk = async () => {
    await deleteRegisterDetails({
      variables: {
        deleteRegisterDetailId: selectedProperty?.id,
      },
    });
  };

  const handleCancel = () => {
    setSelectedProperty();
    setShowModal(false);
  };

  return (
    <div>
      <Modal
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <h2 className="mb-15">Delete Detail</h2>
        <p>Are you sure you want to delete ?</p>
        <div className="form-buttons">
          <Button
            id="delete-property-cancel-btn"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="delete-property-confirm-btn"
            shape="round"
            className="save-button"
            onClick={handleOk}
            type="primary"
          >
            Yes, Delete
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DeletePropertyModal;
